import { render, staticRenderFns } from "./ShopCommentManage.vue?vue&type=template&id=7880a5ce&scoped=true"
import script from "./ShopCommentManage.vue?vue&type=script&lang=js"
export * from "./ShopCommentManage.vue?vue&type=script&lang=js"
import style0 from "./ShopCommentManage.vue?vue&type=style&index=0&id=7880a5ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7880a5ce",
  null
  
)

export default component.exports